module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/wrapper-panels.component.scss
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/wrapper-panels.component.scss
// module chunks = main